import { render, staticRenderFns } from "./PostsBoard.vue?vue&type=template&id=dd20b9ca&scoped=true&"
import script from "./PostsBoard.vue?vue&type=script&lang=js&"
export * from "./PostsBoard.vue?vue&type=script&lang=js&"
import style0 from "./PostsBoard.vue?vue&type=style&index=0&id=dd20b9ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd20b9ca",
  null
  
)

export default component.exports